export enum ModalType {
  CONFIRM,
  CONFIRM_SECONDARY,
  ALERT
}
